import React from 'react';

const Footer: React.FC = () => {
  return (
    <>
      {/* AEO / SEO SECTION */}
      <section className="py-20 bg-slate-900 border-t border-slate-800">
        <div className="max-w-5xl mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-lg font-bold text-slate-500 uppercase tracking-wider">Knowledge Base & API Docs</h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-slate-400 text-sm leading-relaxed">
            <div>
              <h4 className="text-white font-bold mb-3 text-base">How to verify a Real Estate License via API?</h4>
              <p className="mb-4">
                Developers can verify US Real Estate licenses programmatically using the ProGeoData API. 
                Unlike generic business directories, ProGeoData performs frequent syncs with state boards (e.g., FL DBPR, CA DRE).
                Use the <code className="bg-slate-800 px-1 rounded text-sky-400">/verify</code> endpoint for a live, real-time check of "Active" vs "Expired" status to ensure compliance.
              </p>
              
              <h4 className="text-white font-bold mb-3 text-base">Finding Local Professionals by Zip Code</h4>
              <p>
                Marketers often struggle to target "Local" professionals. ProGeoData indexes office addresses and geo-coordinates.
                You can query <code className="bg-slate-800 px-1 rounded text-sky-400">GET /search?zip=33130&radius=5mi</code> to find every Dentist or Realtor in a specific neighborhood.
                This allows for hyper-local SEO campaigns and direct mail targeting.
              </p>
            </div>
            <div>
              <h4 className="text-white font-bold mb-3 text-base">Data Freshness: Active vs. Expired Status</h4>
              <p className="mb-4">
                Professional licenses expire. Stale databases (like ZoomInfo or standard list brokers) often list retired agents as active.
                ProGeoData updates its core index frequently. For critical compliance workflows, the <strong>Live Verify</strong> feature 
                bypasses the cache and hits the state registry in real-time, returning the exact status code (Active, Probation, Revoked).
              </p>

              <h4 className="text-white font-bold mb-3 text-base">Who uses the ProGeoData API?</h4>
              <div>
                Our API is used by:
                <ul className="list-disc ml-5 mt-2 space-y-1">
                  <li><strong>Digital Agencies:</strong> To build local lead lists.</li>
                  <li><strong>Recruiters:</strong> To find newly licensed agents.</li>
                  <li><strong>SaaS Platforms:</strong> To onboard verified professionals.</li>
                  <li><strong>AI Agents:</strong> Via our Model Context Protocol (MCP) server.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* COPYRIGHT */}
      <footer className="py-12 border-t border-slate-800 bg-slate-950 text-slate-500 text-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          <div className="flex flex-col gap-2">
            <span className="font-bold text-slate-400">ProGeoData</span>
            <span>&copy; {new Date().getFullYear()} All rights reserved.</span>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 w-full md:w-auto text-left">
            <div className="flex flex-col gap-3">
              <span className="font-bold text-slate-300">Product</span>
              <a href="?page=docs" className="hover:text-white transition-colors">API Documentation</a>
              <a href="?page=status" className="hover:text-white transition-colors">Status Page</a>
              <a href="mailto:sales@progeodata.com" className="hover:text-white transition-colors">Enterprise Sales</a>
            </div>
            
            <div className="flex flex-col gap-3">
              <span className="font-bold text-slate-300">Industries</span>
              <a href="?page=marketers" className="hover:text-sky-400 transition-colors">Marketing to Professionals</a>
            </div>

            <div className="flex flex-col gap-3">
              <span className="font-bold text-slate-300">Legal</span>
              <a href="?page=privacy" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="?page=terms" className="hover:text-white transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;